import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

const icon_expand:string = "keyboard_arrow_down";
const icon_collapse:string =  "keyboard_arrow_up";

@Component({
  selector: 'app-expandpanel',
  templateUrl: './expandpanel.component.html',
  styleUrls: ['./expandpanel.component.scss']
})
export class ExpandpanelComponent implements OnInit {

  @Input() isExpanded:boolean = false;
  @Input() parentPanel:string = "";
  @Input() arrow_icon:string = icon_expand;
  @Input() panelTitle = "This is my title";
  @Input() parent: boolean = false;
  @Output() expandOutput = new EventEmitter();
  
  error: any;
  element: any;

  constructor() { }

  ngOnInit(): void {
  }

  //handle the expand/close events
  expandClick(element: any) {
    // this.isExpanded ? this.isExpanded = false : this.isExpanded = true;
    //this.isExpanded ? this.arrow_icon = icon_collapse : this.arrow_icon = icon_expand;
    this.expandOutput.next(this);
    this.element = element;
    setTimeout(() => {
      this.element.target.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
    }, 50);
  }

}
